import {createClient} from "@cpmis/gwfetch"

const clientSettings = {
    env: process.env.REACT_APP_API_ENV
}
const gwFetchInstance = createClient(clientSettings);

const GWFetchSend = gwFetchInstance.send;

// Used to easily switch to fetch instead of gwfetch for debugging in local development environment
if (process.env.REACT_APP_USE_FETCH === "true") {
    gwFetchInstance.send = function () {
        const [, options, useGWFetch] = arguments;

        if (useGWFetch) return GWFetchSend(...arguments);

        options.headers = {
            ...options.headers,
            "chkp-api-token": process.env.REACT_APP_API_JWT,
        };

        return fetch(...arguments);
    }
}


export default gwFetchInstance;
